import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppState } from '../../app.service';
import { ToastHelperService } from '../../../services/toast-helper.service';
import { ProfileService } from '../../../services/profile.service';

export class emailVerificationModalContext {
  email?: string
}

@Component({
  selector: 'app-email-verification-needed-modal',
  imports: [CommonModule, TranslateModule],
  styleUrl: './email-verification-needed-modal.component.scss',
  templateUrl: './email-verification-needed-modal.component.html'
})
export class emailVerificationModalComponent {
  public context: any;
  public email;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<emailVerificationModalContext>,
    private profileService: ProfileService,
    private appState: AppState,
    private toastHelper: ToastHelperService,
    private translate: TranslateService
  ) {
    this.context = data;
    this.email = this.context.email;
  }
  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  beforeDismiss(): boolean {
    return this.beforeClose();
  }
  closeDialog(result?): void {
    this.beforeDismiss();
    this.dialog.close(result);
  }
  public sendCode(): void {
    this.appState.loading = true;
    this.profileService.sendVerificationEmail(this.email).then(() => {
      this.appState.loading = false;
      this.toastHelper.success(this.translate.instant('email-verification-modal.toast-sent'));
      this.closeDialog('sent')
    }, (error) => {
      this.appState.loading = false;
      this.closeDialog('error')
    })
  }
}
